export default {
  namespaced: true,
  state: {
    isUpdateApplyList: false, // 是否更新申请列表
  },
  getters: {
    isUpdateApplyList: state => state.isUpdateApplyList,
  },
  mutations: {
    // 更新申请列表
    updateApplyList(state, data) {
      state.isUpdateApplyList = data;
    }
  },
  actions: {},
};
